import { render, staticRenderFns } from "./CartWidget.vue?vue&type=template&id=e0041946&"
import script from "./CartWidget.vue?vue&type=script&lang=ts&"
export * from "./CartWidget.vue?vue&type=script&lang=ts&"
import style0 from "./CartWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports